import { SafePromise } from '@benzinga/safe-await';

import { StockSymbol } from '@benzinga/session';
import {
  CryptoChartMultiply,
  CryptoChartResponse,
  CryptoChartTime,
  ChartInterval,
  ChartRange,
  Candle,
} from '../entities';

import { ChartDataResponse } from '../entities';
import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { ChartEnvironment } from '../environment';

export class ChartRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ChartEnvironment).url, session);
  }

  getChart = (options: {
    symbol: StockSymbol;
    from: string;
    to?: string;
    interval: ChartInterval;
    extendedSession?: 'ANY';
    apiKey?: string;
  }): SafePromise<ChartDataResponse> => {
    const { apiKey, extendedSession = 'ANY', from, interval, symbol, to } = options;
    const url = this.URL(`v2/chart`, {
      apikey: apiKey || this.session.getEnvironment(ChartEnvironment).key,
      from,
      interval,
      session: extendedSession,
      symbol,
      to,
    });
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      includeHeader: { authorization: true },
    });
  };

  getCryptoChart = (
    symbol: StockSymbol,
    from: string,
    to: string,
    multiply: CryptoChartMultiply,
    time: CryptoChartTime,
  ): SafePromise<CryptoChartResponse> => {
    const hostname = new URL(this.session.getEnvironment(ChartEnvironment).cryptoUrl);
    const url = this.URL(`${hostname}api/crypto/chart`, {
      from,
      limit: 500,
      multiply,
      symbol,
      time,
      to,
    });
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      includeHeader: { authorization: true },
    });
  };

  getEmbedChart = (symbol: StockSymbol, timeframe: ChartRange): SafePromise<{ data: Candle[] }> => {
    const url = this.URL(`${window.location.origin}/embed/api/chart`, {
      symbol,
      timeframe,
    });

    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'include',
    });
  };
}
